import { Card, CardBody, Col, Row } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { MarginTitle, OneSideMarginTitle } from "../../../../Constants/Constants";
import { OneSideMarginSubTitle, OneSidePaddingData } from "../../../../Data/UiKits/HelperClasses";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const OneSideMargin = () => {
  return (
    <Col xl="12">
      <Card className="height-equal">
        <CommonCardHeader title={OneSideMarginTitle} span={OneSideMarginSubTitle} />
        <CardBody>
          <Row className="g-3">
            {OneSidePaddingData.map((item) => (
              <Col xxl="3" sm="6" key={item.id}>
                <div className="border-wrapper h-100 alert-light-light dark-helper">
                  <H6 className="mb-3">
                    {MarginTitle} {item.title}
                  </H6>
                  <div className="common-p-box">
                    {item.box.map((padding) => (
                      <span key={padding.id}>{`.m-${padding.text}`}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default OneSideMargin;
